import TextCreate from 'core/display/simple/Text'

export default class ClockText extends TextCreate{
  constructor(data) {
    super(data)

    setInterval(this.tick.bind(this), 1000)
  }

  tick() {
    this.update(this.getTime())
  }

  getTime() {
    const date = new Date()
    const h = date.getHours().toString().padStart(2, '0')
    const m = date.getMinutes().toString().padStart(2, '0')
    return `${h}:${m}`
  }
}
